import Icon from '../../components/Icon.vue'

Icon.register({"regular/folder":{"width":512,"height":512,"paths":[{"d":"M464 128H272L217.4 73.4C211.4 67.4 203.2 64 194.7 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V176C512 149.5 490.5 128 464 128zM464 400H48V112H188.1L242.8 166.6C248.8 172.6 256.9 176 265.4 176H464V400z"}]}})
